import { IoIosArrowBack } from "react-icons/io";
// import H_Nav from '../home/H_Nav';
import "../style/login/Register.scss";
import icon1 from "../../assets/login/google.svg";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/index";

const Register = ({mode}) => {
  let Lcw = 25;
  if(mode===2){
    Lcw = 100;
  }
  else{
    Lcw = 25;
  }
  const changeLabelPosition = () => {
    let label = document.querySelector(".Register-container-username-box-label");
    label.style.top = "-4px";
    label.style.right = "15px";
    label.style.backgroundColor = "#FFF";
    label.style.color = "#2E81E8";
    document.querySelector(
      "#Register-container-username-box-input"
    ).style.borderColor = "#2E81E8";
  };
  const backToDefault = (e) => {
    if (e.target.value.length === 0) {
      let label = document.querySelector(".Register-container-username-box-label");
      label.style.top = "50%";
      label.style.right = "10px";
      label.style.color = "#B5B5B5";
      document.querySelector(
        "#Register-container-username-box-input"
      ).style.borderColor = "#E0E0E0";
    }
  };
  const changeLabelPosition2 = () => {
    let label = document.querySelector(".Register-container-password-box-label");
    label.style.top = "-4px";
    label.style.right = "15px";
    label.style.backgroundColor = "#FFF";
    label.style.color = "#2E81E8";
    document.querySelector(
      "#Register-container-password-box-input"
    ).style.borderColor = "#2E81E8";
  };
  const backToDefault2 = (e) => {
    if (e.target.value.length === 0) {
      let label = document.querySelector(".Register-container-password-box-label");
      label.style.top = "50%";
      label.style.right = "10px";
      label.style.color = "#B5B5B5";
      document.querySelector(
        "#Register-container-password-box-input"
      ).style.borderColor = "#E0E0E0";
    }
  };
  const changeLabelPosition3 = () => {
    let label = document.querySelector(".Register-container-repeat-password-box-label");
    label.style.top = "-4px";
    label.style.right = "15px";
    label.style.backgroundColor = "#FFF";
    label.style.color = "#2E81E8";
    document.querySelector(
      "#Register-container-repeat-password-box-input"
    ).style.borderColor = "#2E81E8";
  };
  const backToDefault3 = (e) => {
    if (e.target.value.length === 0) {
      let label = document.querySelector(".Register-container-repeat-password-box-label");
      label.style.top = "50%";
      label.style.right = "10px";
      label.style.color = "#B5B5B5";
      document.querySelector(
        "#Register-container-repeat-password-box-input"
      ).style.borderColor = "#E0E0E0";
    }
  };
  const changeLabelPosition4 = () => {
    let label = document.querySelector(".Register-container-email-or-phoneNumber-box-label");
    label.style.top = "-4px";
    label.style.right = "15px";
    label.style.backgroundColor = "#FFF";
    label.style.color = "#2E81E8";
    document.querySelector(
      "#Register-container-email-or-phoneNumber-box-input"
    ).style.borderColor = "#2E81E8";
  };
  const backToDefault4 = (e) => {
    if (e.target.value.length === 0) {
      let label = document.querySelector(".Register-container-email-or-phoneNumber-box-label");
      label.style.top = "50%";
      label.style.right = "10px";
      label.style.color = "#B5B5B5";
      document.querySelector(
        "#Register-container-email-or-phoneNumber-box-input"
      ).style.borderColor = "#E0E0E0";
    }
  };
  const dispatch = useDispatch();
  const { dashNav } = bindActionCreators(actionCreators, dispatch);

  const ShowNav = () => {
    dashNav();
  };
  
  return (
    <div className="Register" style={mode===2 ? {marginTop:"30px"}:null}>
      {/* <H_Nav/> */}
      <div style={{width:`${Lcw}%`}} className="Register-container">
        {(mode===1) && <div className="Register-container-back-btn-box">
          <IoIosArrowBack className="Register-container-back-btn-box-icon" />
          <Link to="/" className="Register-container-back-btn-box-text">
            بازگشت به صفحه اصلی
          </Link>
        </div>}
        <div className="Register-container-title">
          سلام <br />
          خوش حالیم که ما رو انتخاب کردید!
        </div>
        <div className="Register-container-username-box">
          <label
            className="Register-container-username-box-label"
            htmlFor="Register-container-username-box-input"
          >
            نام کاربری
          </label>
          <input
            type="text"
            name="Register-container-username-box-input"
            id="Register-container-username-box-input"
            onFocus={changeLabelPosition}
            onBlur={(e) => backToDefault(e)}
          />
        </div>
        <div className="Register-container-email-or-phoneNumber-box">
          <label
            className="Register-container-email-or-phoneNumber-box-label"
            htmlFor="Register-container-email-or-phoneNumber-box-input"
          >
            ایمیل یا شماره موبایل 
          </label>
          <input
            type="text"
            name="Register-container-email-or-phoneNumber-box-input"
            id="Register-container-email-or-phoneNumber-box-input"
            onFocus={changeLabelPosition4}
            onBlur={(e) => backToDefault4(e)}
          />
        </div>
        <div className="Register-container-password-box">
          <label
            className="Register-container-password-box-label"
            htmlFor="Register-container-password-box-input"
          >
            رمز عبور
          </label>
          <input
            type="password"
            name="Register-container-password-box-input"
            id="Register-container-password-box-input"
            onFocus={changeLabelPosition2}
            onBlur={(e) => backToDefault2(e)}
          />
        </div>
        <div className="Register-container-repeat-password-box">
          <label
            className="Register-container-repeat-password-box-label"
            htmlFor="Register-container-repeat-password-box-input"
          >
            تکرار رمز عبور
          </label>
          <input
            type="password"
            name="Register-container-repeat-password-box-input"
            id="Register-container-repeat-password-box-input"
            onFocus={changeLabelPosition3}
            onBlur={(e) => backToDefault3(e)}
          />
        </div>
        <Link
          to="/login"
          className="Register-container-enter-btn"
        >
          ثبت نام
        </Link>
        <div className="Register-container-line-box">
          <div className="Register-container-line-box-item"></div>
          <div className="Register-container-line-box-text">یا</div>
          <div className="Register-container-line-box-item"></div>
        </div>
        <div className="Register-container-enter-btn-with-google">
          <img src={icon1} alt="google-logo" />
          <div className="Register-container-enter-btn-with-google-text">
            ثبت نام با اکانت گوگل
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;